import {HeadingProps} from 'react-markdown/lib/ast-to-react';

import {Text} from '#component/base';

import {heading2} from '../Markdown.css';

export const Heading2 = ({children}: React.PropsWithChildren<HeadingProps>) => {
  return (
    <Text as="h2" variant="heading4" className={heading2}>
      {children}
    </Text>
  );
};
